/**
 * Imports the necessary modules from the React library for a React component.
 * @module React
 * @module useState
 * @module useTranslation
 */
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Imports the necessary components and utilities for the current module.
 * @import CustomButton from "../../components/customButton/customButton" - The custom button component.
 * @import ConfirmModal from "../../components/confirmModal/confirmModel" - The confirm modal component.
 * @import TextField from "../../components/TextField/TextField" - The text field component.
 * @import HookForm from "../../components/HookForm/HookForm" - The hook form component.
 * @import Constant from "../../util/constant" - The constant utility module.
 */
import ConfirmModal from "../../components/confirmModal/confirmModel";
import CustomButton from "../../components/customButton/customButton";
import HookForm from "../../components/hookForm/hookForm";
import TextField from "../../components/textField/textField";
import Constant from "../../util/constant";

/**
 * A component that renders a modal for creating or editing a category.
 * @param {{object}} props - The props object containing various properties and functions.
 * @returns The JSX element representing the CreateCategory component.
 */
const CreateCategory = (props) => {
  const { t } = useTranslation();

  const {
    showCreateCategoryModal,
    closeCreateCategoryModal,
    modalName,
    createCategoryModelLoaderButton,
    handleCategorytextChange,
    categorytextcount,
    placeholder,
    updateCategoryModelLoaderButton,
    handleSubmitCreate,
    label,
    createCategoryFunction,
    categoryValue,
  } = props;

  const CreateCategory = {
    categoryname: {
      name: "categoryname",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: Constant.REGEX.ALPHANUMERICSPECIALCHAR,
          message: t("ALLOWED_ONLY_ALPHABETS_NUMBERS_AND_SPECIALCHARACTERS"),
        },
        maxLength: {
          value: 100,
          message: t("ALLOWED_MAX_100_CHARACTERS"),
        },
      },
    },
  };

  return (
    <ConfirmModal
      className={"Deactivate import-model"}
      modalTitle={
        modalName.modal === "add" ? t("CREATE_CATEGORY") : t("EDIT_CATEGORY")
      }
      showModal={showCreateCategoryModal}
      isModelIcon={false}
      modalContent={false}
      isFirstButton={false}
      isSecondButton={false}
      onProcced={() => {}}
      closeModelIcon={() => closeCreateCategoryModal()}
      isCloseBtn={true}
    >
      {/**
       * Renders a form component with input fields for creating a category.
       * @param {Object} defaultForm - The default form values.
       * @param {string} className - The CSS class name for the form.
       * @param {Function} init - The initialization function for the form.
       * @returns The rendered form component.
       */}
      <HookForm
        defaultForm={{
          categoryname: modalName.modal === "add" ? "" : categoryValue,
        }}
        className="form-horizontal"
        init={(form) => {
          createCategoryFunction(form);
        }}
        onSubmit={(e) => {
          handleSubmitCreate(e);
        }}
      >
        {(formMethod) => {
          return (
            <>
              <div className="uploadWrapper createPageWrapper">
                <div className="d-flex">
                  <p className="form-label">{label}</p>
                  <p className="requiredStyle">*</p>
                </div>
                <div className="textFiledWrapper wrapper-input">
                  <TextField
                    formMethod={formMethod}
                    rules={CreateCategory.categoryname.validate}
                    name={CreateCategory.categoryname.name}
                    errors={formMethod?.formState.errors}
                    autoFocus={true}
                    // maxLength={200}
                    textCountVisible={true}
                    textcount={categorytextcount}
                    textCountTotal={100}
                    maxLength="100"
                    required={false}
                    type="text"
                    placeholder={placeholder}
                    onChange={
                      modalName.modal === "add"
                        ? handleCategorytextChange
                        : handleCategorytextChange
                    }
                  />
                </div>
              </div>
              <div className="Form_buton">
                <CustomButton
                  className="black-btn fillButton"
                  disabled={
                    modalName.modal === "add"
                      ? !formMethod?.formState.isValid
                      : !formMethod?.formState.isDirty
                  }
                  loading={
                    modalName.modal === "add"
                      ? createCategoryModelLoaderButton
                      : updateCategoryModelLoaderButton
                  }
                  type="submit"
                >
                  {modalName.modal === "add" ? t("ADD_CATEGORY") : t("UPDATE")}
                </CustomButton>
                <CustomButton
                  className="black-btn borderButton"
                  onClick={() => {
                    closeCreateCategoryModal(true);
                  }}
                  type="button"
                >
                  {t("CANCEL")}
                </CustomButton>
              </div>
            </>
          );
        }}
      </HookForm>
    </ConfirmModal>
  );
};

export default CreateCategory;
